<script>
import options from './TilmeldProfilKvittering.options'
export default options
</script>

<template>
  <article class="kb-tilmeld-profil-kvittering">
    <section class="kb-tilmeld-profil-kvittering__hero">
      <div class="kb-tilmeld-profil-kvittering__hero__title-wrapper">
        <div class="kb-tilmeld-profil-kvittering__hero__hero-title-circle">
          <div class="kb-tilmeld-profil-kvittering__hero__hero-title-icon">
            <svg viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.7998 12L8.6998 19.2L20.1998 0.799988" stroke="white" stroke-width="2.3"
                stroke-linejoin="round" />
            </svg>
          </div>
        </div>
        <h2 class="kb-tilmeld-profil-kvittering__hero__title-wrapper__title">
          {{
            getLabel('title')
          }}
        </h2>
      </div>
      <div class="kb-tilmeld-profil-kvittering__breaker">
        <svg viewBox="0 0 81 11" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 .5h79v1H2v-1ZM1.5 2v9h-1V2h1Zm.5-.5a.5.5 0 0 0-.5.5h-1A1.5 1.5 0 0 1 2 .5v1Z" />
        </svg>
      </div>
      <p class="kb-tilmeld-profil-kvittering__success-text">
        {{
              getLabel('text')
            }}
      </p>
    </section>
    <div class="kb-tilmeld-profil-kvittering__hero__curve">
      <svg viewBox="0 0 720 77" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0V42.4078C238.547 71.2459 479.584 82.0555 720 74.8278V0H0Z" />
      </svg>
    </div>

    <div class="kb-tilmeld-profil-kvittering__content-container">

    </div>
  </article>
</template>
